import type { IconSvgObject } from './types';

const TwitchIcon: IconSvgObject = [
  ["path", { d: "M16.001 7L16 11M12.001 7L12 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 3H4V16.5L7 16.5226V21L11.0355 16.5226H17.0094L20 13.5V3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TwitchIcon;
